








































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AcgnPop } from '@acgn/herm/src/ui';
import { Popover } from 'element-ui';
import { namespace } from 'vuex-class';
const TaskGroupAction = namespace('desk/taskGroup').Action;
const TaskGroupGetter = namespace('desk/taskGroup').Getter;
import { complexClone } from '@acgn/herm/src/util/serialize';

@Component({
  components: {
    AcgnPop,
    [Popover.name]: Popover
  }
})
export default class AcgnSortGroup extends Vue {
  @Prop() public visible: any; // 是否显示弹框
  @Prop() public editTaskItem: any; // 当前任务
  @Prop() public refreshTaskList: any; // 刷新任务列表
  @Prop() public taskItemId: any; // 默认任务组id
  private selectList: any = []; // 任务组列表
  private selectId: any = []; // 任务组默认id
  private menuList: any = [
    { name: '之上', id: 0 },
    { name: '之下', id: 1 }
  ]; // 之上之下
  private defaultMenu: any = 0;
  @TaskGroupAction private getTaskStatus: any; // 获取任务
  @TaskGroupAction private setTaskOrder: any; // 任务排序
  @TaskGroupGetter private loadings: any; // 任务组loading

  @Watch('visible')
  private async getVisible() {
    if (this.show) {
      this.selectId = this.editTaskItem.id;
      const {result} = await this.getTaskStatus({task_group_id: this.taskItemId});
      this.selectList = result;
    }
  }
  get show() {
    return this.visible;
  }

  set show(v) {
    this.$emit('update:visible', v);
  }

  private getChangeList(group: any, select: any) {
    let ready: any = false;
    let lastIndex: any = 0;
    let insertIndex: any = 0;
    let popIndex: any = 0;
    let tempItem: any = {};
    let arr = complexClone(this.selectList);
    arr.map((item: any, index: any) => {
      if (!ready) {
        if (item.id === group) {
          tempItem = item;
          popIndex = index;
          ready = true;
        }
        if (item.id === select) {
          ready = true;
          insertIndex = index;
        }
      } else {
        if (item.id === group) {
          tempItem = item;
          popIndex = index;
          lastIndex = index;
        }
        if (item.id === select) {
          insertIndex = index;
          lastIndex = index;
        }
      }
    });
    if (lastIndex <= 0) {
      return false;
    }
    if (this.defaultMenu === 0) {
      arr.splice(insertIndex, 0, tempItem);
    } else {
      arr.splice(insertIndex + 1, 0, tempItem);
    }
    if (popIndex > insertIndex) {
      arr.splice(popIndex + 1, 1);
    } else {
      arr.splice(popIndex, 1);
    }
    let temp = lastIndex < arr.length - 1 ? arr[lastIndex + 1].task_order : 0;
    arr = arr.slice(0, lastIndex + 1).reverse();
    const backData: any = [];
    arr.map((i: any) => {
      backData.push({
        id: i.id,
        order_num: ++temp
      });
    });
    return backData;
  }

  // 提交任务组
  private async submit() {
    try {
      const data = this.getChangeList(this.editTaskItem.id, this.selectId);
      if (!data) {
        this.$message.error('移动对象和移动位置不能一致');
        return false;
      }
      await this.setTaskOrder({ orders: data });
      await this.refreshTaskList();
      this.$message.success('排序成功');
      this.show = false;
    } catch (ex) {
      this.$message.error(ex.message);
    }
  }
}
